// src/utils/request.js

// Vue CLI 创建的 Vue 3 项目使用 process.env
// 不是 import.meta.env

// 获取环境变量
const BASE_API = process.env.VUE_APP_BASE_API || '/prod-api'


import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
    baseURL: BASE_API,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    // 如果是跨域请求，可能需要这个
    withCredentials: false
})

let loadingInstance = null
let requestCount = 0


// 隐藏 loading
function hideLoading() {
    requestCount--
    if (requestCount <= 0) {
        loadingInstance && loadingInstance.close()
        loadingInstance = null
        requestCount = 0
    }
}

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 添加 token
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }

        // GET 请求添加时间戳防止缓存
        if (config.method?.toLowerCase() === 'get') {
            config.params = {
                ...config.params,
            }
        }

        return config
    },
    error => {
        hideLoading()
        ElMessage.error('请求发送失败')
        return Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // 根据业务逻辑处理
        // 假设 code 200 为成功
        if (res.code === 200 || res.code === 0 || res.success === true) {
            return res.data || res
        } else {
            console.log('响应数据:', res.code)
            const errorMsg = res.message || res.msg || '请求失败'
            ElMessage.error(errorMsg)
            return res
        }
    },
    error => {
        hideLoading()
        console.log('响应错误:', error)
        // 处理网络错误
        if (error.code === 'ECONNABORTED') {
            ElMessage.error('请求超时，请检查网络')
        } else if (error.code === 'ERR_NETWORK') {
            ElMessage.error('网络错误，请检查：\n1. 后端服务是否启动\n2. 代理配置是否正确')
        } else if (error.response) {
            // 处理 HTTP 状态码错误
            switch (error.response.status) {
                case 400:
                    ElMessage.error('请求参数错误')
                    break
                case 401:
                    ElMessage.error('未授权，请重新登录')
                    localStorage.removeItem('token')
                    router.push('/')
                    break
                case 403:
                    ElMessage.error('拒绝访问')
                    break
                case 404:
                    ElMessage.error('请求地址不存在')
                    break
                case 500:
                    ElMessage.error('服务器内部错误')
                    break
                default:
                    ElMessage.error(`请求失败: ${error.response.status}`)
            }
        } else if (error.request) {
            ElMessage.error('网络连接失败，请检查网络')
        } else {
            ElMessage.error('请求配置错误: ' + error.message)
        }

        return Promise.reject(error)
    }
)

// 封装请求方法
const request = {
    get(url, params = {}, config = {}) {
        return service({
            method: 'get',
            url,
            params,
            ...config
        })
    },

    post(url, data = {}, config = {}) {
        return service({
            method: 'post',
            url,
            data,
            ...config
        })
    },

    put(url, data = {}, config = {}) {
        return service({
            method: 'put',
            url,
            data,
            ...config
        })
    },

    delete(url, params = {}, config = {}) {
        return service({
            method: 'delete',
            url,
            params,
            ...config
        })
    },

    // 测试方法
    testConnection() {
        return this.get('/test', {}, {
            showLoading: true,
            loadingText: '测试连接中...'
        })
    }
}

export default request